import { useMemo, ReactNode } from 'react'
// material
import { CssBaseline } from '@mui/material'
import {
  createTheme,
  ThemeOptions,
  ThemeProvider,
  StyledEngineProvider
} from '@mui/material/styles'
//
import shape from './shape'
import palette from './palette'
import typography from './typography'
import breakpoints from './breakpoints'

// ----------------------------------------------------------------------

type ThemeConfigProps = {
  children: ReactNode
}

export default function ThemeConfig({ children }: ThemeConfigProps) {
  let variable = 'light'
  /*@ts-ignore*/
  if (window?.brand === 'nab') {
    variable = 'nab'
  }
  const themeOptions: ThemeOptions = useMemo(
    () => ({
      palette: {
        ...palette[variable] || palette.light,  // Fallback to `light` if `nab` is not fully defined
        mode: variable === 'nab' ? 'light' : variable,  // Ensure mode is either 'light' or 'dark'
      },
      shape,
      typography,
      breakpoints
    }),
    []
  )

  const theme = createTheme(themeOptions)

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  )
}
